/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseSetItem
 */
export interface ResponseSetItem {
    /**
     * 納品数
     * @type {number}
     * @memberof ResponseSetItem
     */
    arriveCount?: number;
    /**
     * 予定入荷総数
     * @type {number}
     * @memberof ResponseSetItem
     */
    expectedCount?: number;
    /**
     * 賞味期限（任意）
     * @type {string}
     * @memberof ResponseSetItem
     */
    expiryDate?: string;
    /**
     * JANコード
     * @type {string}
     * @memberof ResponseSetItem
     */
    jan?: string;
    /**
     * 商品名
     * @type {string}
     * @memberof ResponseSetItem
     */
    name?: string;
    /**
     * セット数
     * @type {number}
     * @memberof ResponseSetItem
     */
    setCount?: number;
}

/**
 * Check if a given object implements the ResponseSetItem interface.
 */
export function instanceOfResponseSetItem(value: object): value is ResponseSetItem {
    return true;
}

export function ResponseSetItemFromJSON(json: any): ResponseSetItem {
    return ResponseSetItemFromJSONTyped(json, false);
}

export function ResponseSetItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseSetItem {
    if (json == null) {
        return json;
    }
    return {
        
        'arriveCount': json['arrive_count'] == null ? undefined : json['arrive_count'],
        'expectedCount': json['expected_count'] == null ? undefined : json['expected_count'],
        'expiryDate': json['expiry_date'] == null ? undefined : json['expiry_date'],
        'jan': json['jan'] == null ? undefined : json['jan'],
        'name': json['name'] == null ? undefined : json['name'],
        'setCount': json['set_count'] == null ? undefined : json['set_count'],
    };
}

export function ResponseSetItemToJSON(json: any): ResponseSetItem {
    return ResponseSetItemToJSONTyped(json, false);
}

export function ResponseSetItemToJSONTyped(value?: ResponseSetItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'arrive_count': value['arriveCount'],
        'expected_count': value['expectedCount'],
        'expiry_date': value['expiryDate'],
        'jan': value['jan'],
        'name': value['name'],
        'set_count': value['setCount'],
    };
}

